export const SYSTEM_THEMES = {
  'sali': 'theme-sali',
  'hlmra': 'theme-hlmra',
  'ra': 'theme-ra',
  'valladolid': 'theme-valladolid',
};
